import * as ActionTypes from '../actionTypes';

export const user = (
  state = {
    token: '',
    plant: '',
    line: '',
    station: '',
    isAuthenticated: false,
    cycleTime: 0,
  },
  action,
) => {
  switch (action.type) {
    case ActionTypes.UPDATE_TOKEN:
      localStorage.setItem('user', JSON.stringify({
        ...state,
        ...action.payload
      }));
      return {
        ...state,
        ...action.payload
      };
    default:
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData) {
        return {
          ...state,
          ...userData
        };
      }
      return state;
  }
};
